import hiringRequestsAPI from 'api/hiringRequestsAPI';
import { HiringRequestScorecard } from '../types';
import { ScorecardToSubmit } from './Panes/Create/Scorecard/components/types';

export const editHiringRequestScorecard = (
  hiringRequestId: number,
  scorecardId: number,
  payload: ScorecardToSubmit | FormData
): Promise<HiringRequestScorecard> => {
  return hiringRequestsAPI.editScorecard(hiringRequestId, scorecardId, payload).then((res) => res);
};

export const deleteHiringRequestScorecard = (
  hiringRequestId: number,
  scorecardId: number
): Promise<HiringRequestScorecard> => {
  return hiringRequestsAPI.deleteScorecard(hiringRequestId, scorecardId).then((res) => res);
};
